module.exports = __webpack_public_path__ + "img/logo-white.46e9a4c0.png";